import React from 'react';
import { boss } from '../../../../assets/png';
import { Box, Text, Title } from '../../../../components';
import {
  COLORS,
  CONTACT_US_TITLE,
  device,
  FONTS,
  ROUTES,
} from '../../../../constants';
import styled from 'styled-components';
import { NavLink as Link } from 'react-router-dom';
import Cta from '../../../home/partials/Cta/Cta';
import { SectionContainer } from '../../styles';
import { AboutUsContact as AboutUsContactType } from '../../../../services/about-us/fetchAboutUsPageContent';
import { CtaPhoto } from '../../../../components/CtaPhoto/CtaPhoto';
import { MotionText } from '../../../../components/Motion';

interface AboutUsContactProps {
  data: AboutUsContactType;
}

const AboutUsContact = ({ data }: AboutUsContactProps) => {
  return (
    <SectionContainer $color={COLORS.ABOUT_US_CTA_BG}>
      <Box>
        <CtaWrapper>
          <CtaPhoto src={boss} />
          <ContentWrapper>
            <TextWrapper>
              <Title title={data.Title} color={COLORS.WHITE} />
              {data.Subtitle.split('/').map((item, index) => (
                <Text
                  key={index}
                  text={item}
                  fontFamily={FONTS.SUBTITLE}
                  size={22}
                  lineHeight={28}
                  color={COLORS.HEADER_TEXT_COLOR}
                />
              ))}
            </TextWrapper>
            <StyledLink to={ROUTES.CONTACT_US}>{CONTACT_US_TITLE}</StyledLink>
          </ContentWrapper>
        </CtaWrapper>
      </Box>
    </SectionContainer>
  );
};

const CtaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media screen and (${device.lg}){
    gap: 40px;
  }
  @media screen and (${device.sm}) {
    gap: 10px;
  }
`;
const ContentWrapper = styled(MotionText)`
  max-width: calc(100% - 720px);
  position: relative;
  z-index: 10;
  
  @media screen and (${device.lg}) {
    max-width: none;
  }
  @media screen and (${device.md}) {
    a {
      margin-top: 15px;
    }
    padding: 10px;
  }
  @media screen and (${device.sm} ){
    a {
      width: 90px;
      padding: 0;
      height: 45px;
      margin-top: 5px;
      font-size: 14px;
      line-height: 1.5;
    }
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  > h4:nth-child(2) {
    max-width: 90%;
  }
  @media screen and (${device.lg}) {
    > h4:nth-child(2) {
      max-width: none;
    }
  }
  @media screen and (${device.md}) {
    > span {
      font-size: 24px;
      line-height: 1.5;
    }
    > h4 {
      font-size: 20px;
      line-height: 1.5;
    }
    gap: 10px;
  }
  @media screen and (${device.bsm}){
    > span {
      font-size: 20px;
    }
    > h4 {
      font-size: 18px;
    }
  }
  @media screen and (${device.sm}) {
    > span {
      font-size: 15px;
    }
    > h4 {
      font-size: 13px;
    }
  }
`;
const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background-color: ${COLORS.MAIN_RED};
  color: ${COLORS.WHITE};
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding: 0;
  width: 130px;
  height: 55px;
  margin-top: 40px;
  font-family: ${FONTS.SUBTITLE};
  &:hover {
    background: ${COLORS.RED_HOVER};
  }
  &:active {
    background: ${COLORS.RED_PRESSED};
  }
  @media screen and (${device.sm}) {
    font-size: 12px;
  }
`;
export default Cta;
export { AboutUsContact };
